// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BREAKPOINTS */
.Navigation_navigation__0mO4f {
  grid-area: navigation;
  height: 100%;
  display: grid;
  align-items: center;
}
.Navigation_navigation__0mO4f .Navigation_toggleNavigation__9bXOs {
  margin-left: -0.5em;
}
@media (min-width: 768px) {
  .Navigation_navigation__0mO4f .Navigation_toggleNavigation__9bXOs {
    display: none;
  }
}
.Navigation_navigation__0mO4f .Navigation_toggleNavigation__9bXOs[aria-expanded=true] {
  position: fixed;
  top: 0;
  right: 15%;
}
.Navigation_navigation__0mO4f .Navigation_toggleNavigation__9bXOs[aria-expanded=true],
.Navigation_navigation__0mO4f .Navigation_toggleNavigation__9bXOs[aria-expanded=true] * {
  z-index: calc(var(--menuIndex) + 2);
}

.nightMode .Navigation_toggleNavigation__9bXOs svg {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/core/_breakpoints.scss","webpack://./src/views/Template/components/Menu/Navigation.module.scss"],"names":[],"mappings":"AAAA,gBAAA;ACCA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AACF;AAAE;EACE,mBAAA;AAEJ;ADFI;ECDF;IAGI,aAAA;EAIJ;AACF;AAHI;EACE,eAAA;EAKA,MAAA;EACA,UAAA;AACN;AANM;;EAEE,mCAAA;AAQR;;AAEI;EACE,YAAA;AACN","sourcesContent":["/* BREAKPOINTS */\n@mixin breakpoint-up($point) {\n  @if $point == sm {\n    @media (min-width: 576px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (min-width: 768px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (min-width: 992px) {\n      @content;\n    }\n  } @else if $point == xl {\n    @media (min-width: 1200px) {\n      @content;\n    }\n  }\n}\n\n@mixin breakpoint-down($point) {\n  @if $point == xs {\n    @media (max-width: 575.98px) {\n      @content;\n    }\n  } @else if $point == sm {\n    @media (max-width: 767.98px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (max-width: 991.98px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (max-width: 1199.98px) {\n      @content;\n    }\n  }\n}\n","@import \"core/_breakpoints.scss\";\n.navigation {\n  grid-area: navigation;\n  height: 100%;\n  display: grid;\n  align-items: center;\n  .toggleNavigation {\n    margin-left: -0.5em;\n    @include breakpoint-up(md) {\n      display: none;\n    }\n    &[aria-expanded=\"true\"] {\n      position: fixed;\n      &,\n      * {\n        z-index: calc(var(--menuIndex) + 2);\n      }\n      top: 0;\n      right: 15%;\n    }\n  }\n}\n\n:global(.nightMode) {\n  .toggleNavigation {\n    svg {\n      color: white;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigation": `Navigation_navigation__0mO4f`,
	"toggleNavigation": `Navigation_toggleNavigation__9bXOs`
};
export default ___CSS_LOADER_EXPORT___;
